import { observer } from 'mobx-react';
import React, { Component } from 'react';
import {Button, Row, Col} from 'reactstrap'
import Card from '../../../comum/components/Card';
import FormInputSimples from '../../../comum/components/FormInputSimples';

@observer
export class FiltroEntradaAntecipada extends Component {
    constructor(props) {
        super(props);
        this.controller = props.controller


    }

    render() {
        let navioSelecionadoFiltro = this.controller.navioSelecionadoFiltro 
        let carregandoNavioFiltro = this.controller.carregandoNavioFiltro

        return ( 
            <Card className="mb-0">
                <div className="filtros agendamento m-0 p-0">  
                    <Row className="align-items-end">
                        <FormInputSimples className="mb-auto mt-1" titulo="N° Booking" xs={12} sm={12} md={4} lg={3} xl={3}
                            uppercase={true} onEnter={() => this.controller.buscarSolicitacoes()}
                            dado={this.controller.numeroBookingFiltro}
                            onChange={(event) => this.controller.setNumeroBookingFiltro(event.target.value.toUpperCase())}
                            onBlur={this.controller.carregarNavioFiltro}
                        />
                        <FormInputSimples className="mb-auto mt-1" titulo="Navio" xs={12} sm={12} md={4} lg={3} xl={3}
                            uppercase={true}
                            value={navioSelecionadoFiltro}
                            bloqueado
                        />
                        <FormInputSimples className="mb-auto mt-1" titulo="Cód. Container" xs={12} sm={12} md={4} lg={3} xl={3}
                            uppercase={true} onEnter={() => this.controller.buscarSolicitacoes()}
                            dado={this.controller.filtroContainer}
                            onChange={(event) => this.controller.setContainerFiltro(event.target.value.toUpperCase())}
                            onBlur={(event) => this.controller.setContainerFiltro(event.target.value.toUpperCase())}
                        />
                        <Col className="mt-1" xs={12} sm={12} md={4} lg={3} xl={3}>
                            <Button className="btn-com-bordas-primary btn-filtrar" onClick={() => this.controller.buscarSolicitacoes()} disabled={carregandoNavioFiltro}>Filtrar</Button>
                        </Col>
                    </Row>
                </div>
            </Card>
        );
    }
}
 


// WEBPACK FOOTER //
// ./src/modules/agendamento/entrada-antecipada/components/FiltroEntradaAntecipada.js